export const fileTypeList = [
  { value: 'jpg' },
  { value: 'pdf' },
]
export const imageSizeList = [
  { value: 70 },
  { value: 100 },
]
